module.exports = __webpack_public_path__ + "media/newstyle/images/stars_2-d46239383d4efda35ba87d0eb487c6b7.svg";